let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6Iwmh")).then(() => parcelRequire('6m8b0'));